import PageHeader from "@/components/PageHeader";
import { Link } from "react-router-dom";
import { Feather, Compass, HeartHandshake } from "lucide-react";

const Nosotros = () => {
  return (
    <div data-testid="nosotros-page">
      <PageHeader
        eyebrow="01 · Nosotros"
        title="Un consultorio pensado para acompañar."
        subtitle="Psychelibrium es un espacio de psicología clínica y forense en línea, guiado por la ética, la formación continua y una escucha profundamente humana."
      />

      <section className="px-6 md:px-14 grid grid-cols-1 lg:grid-cols-5 gap-12 pb-16">
        <div className="lg:col-span-3 space-y-6">
          <p
            className="text-lg leading-relaxed rise"
            style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-black)" }}
          >
            Nacimos con la convicción de que la salud mental merece un espacio
            preparado, cuidadoso y libre de juicios. Cada consulta se construye
            sobre tres pilares: <em>rigor clínico</em>, <em>evidencia científica</em>
            {" "}y <em>presencia humana</em>.
          </p>
          <p
            className="text-lg leading-relaxed rise rise-1"
            style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)" }}
          >
            Atendemos a adolescentes, adultos, parejas y familias, con especial
            atención a la comunidad LGBTQ+, desde una perspectiva integradora
            que combina técnicas cognitivo-conductuales, sistémicas, humanistas y
            de mindfulness.
          </p>
          <p
            className="text-lg leading-relaxed rise rise-2"
            style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)" }}
          >
            Nuestro trabajo también se extiende al ámbito forense, donde
            realizamos dictámenes, peritajes y metaperitajes con la
            independencia y objetividad que exige el sistema de justicia.
          </p>
          <Link to="/especialistas" data-testid="nosotros-cta" className="btn-primary mt-4">
            Conoce a los especialistas
          </Link>
        </div>

        <div className="lg:col-span-2 space-y-5">
          <ValueRow Icon={Compass} title="Misión" text="Ofrecer atención psicológica clínica y forense de excelencia, en línea, accesible y centrada en la persona." />
          <ValueRow Icon={Feather} title="Visión" text="Ser un referente hispanoamericano en psicología integradora, rigor forense y cuidado ético." />
          <ValueRow Icon={HeartHandshake} title="Valores" text="Confidencialidad, honestidad, formación continua, empatía activa y respeto por la diversidad." />
        </div>
      </section>

      <section className="px-6 md:px-14 pb-24">
        <div
          className="relative overflow-hidden rounded-sm p-8 md:p-12"
          style={{ background: "var(--p-burgundy)", color: "var(--p-cream)" }}
        >
          <p className="eyebrow" style={{ color: "var(--p-gold-soft)" }}>Nuestro compromiso</p>
          <blockquote
            className="mt-4 italic max-w-3xl"
            style={{ fontFamily: "Cormorant Garamond, serif", fontSize: "clamp(1.4rem, 2.4vw, 2rem)", lineHeight: 1.35 }}
          >
            “Cada proceso terapéutico es único. Estamos aquí para acompañarte,
            con la paciencia y el rigor que tu historia merece.”
          </blockquote>
        </div>
      </section>
    </div>
  );
};

const ValueRow = ({ Icon, title, text }) => (
  <div
    className="p-5 card-soft"
    style={{ background: "#fbf6ec" }}
  >
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: "rgba(184,151,90,0.15)", color: "var(--p-burgundy)" }}>
        <Icon size={16} strokeWidth={1.4} />
      </div>
      <h3 className="font-deco text-base" style={{ color: "var(--p-burgundy)", letterSpacing: "0.06em" }}>{title}</h3>
    </div>
    <p className="mt-3" style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)", lineHeight: 1.55 }}>
      {text}
    </p>
  </div>
);

export default Nosotros;
